export interface ScheduledRedirectAmplitudeEvent {
    eventType: string;
    eventProperties?: {
        [k: string]:
            | Record<string, unknown>
            | string
            | number
            | boolean
            | undefined;
    };
}

export enum GlobalInformationAlertType {
    ScheduledRedirectNotice = 'scheduledRedirectNotice',
}

export interface ScheduledRedirectValue {
    target: string;
    delayMs?: number;
    amplitudeEvent?: ScheduledRedirectAmplitudeEvent;
    redirectCallback?: () => void;
}

type OneOf<T extends readonly unknown[]> = T[number];

export type GlobalInformationAlertValue = OneOf<[ScheduledRedirectValue]>;
